"use client";

import { cn } from "@/lib/utils";
import { ChoiceBox } from "./ChoiceBox";

/**
 * The stacked "how many past years?" options used by both remediation screens.
 *
 * Rows rather than the wide side-by-side cards used for yes/no answers: these
 * labels are two or three words each.
 */
export function YearChoiceList({
  legend,
  name,
  options,
  value,
  onChange,
}: {
  legend: string;
  /** Radio group name — must differ per screen or the two would share state. */
  name: string;
  options: readonly { id: string; label: string }[];
  value: string | null;
  onChange: (value: string) => void;
}) {
  return (
    <fieldset className="flex w-full flex-col items-start gap-4">
      <legend className="sr-only">{legend}</legend>
      {options.map((option) => {
        const selected = value === option.id;

        return (
          <label
            key={option.id}
            className={cn(
              "flex w-full cursor-pointer items-start gap-2 rounded-2xl bg-[#0F1319] px-5 py-4 outline outline-2 -outline-offset-2 transition-colors sm:px-6",
              selected ? "outline-[#58A6FF]" : "outline-transparent hover:outline-white/20",
            )}
          >
            <input
              type="radio"
              name={name}
              value={option.id}
              checked={selected}
              onChange={() => onChange(option.id)}
              className="peer sr-only"
            />
            <ChoiceBox selected={selected} />
            <span className="flex-1 font-suisse-intl text-base leading-7 text-white sm:text-lg sm:leading-[28.8px]">
              {option.label}
            </span>
          </label>
        );
      })}
    </fieldset>
  );
}
